import { lazy } from 'react'

import { AnyRoute, createRoute, notFound, useLoaderData } from '@tanstack/react-router'
import { getOnboardingDocumentCreateModeWebPage } from 'commons/service/bank/onboardingDocuments'
import { OnboardingDocumentCreateModeWebPage } from 'commons/types/DTO/bank/applications/onboardingDocuments'

import { Sidebar } from '../../components/Sidebar'

const SetupDocumentsCreate = lazy(() => import('./SetupDocumentsCreate'))

export const onboardingDocumentsCreateRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: 'setup',
    loader: async ({ params }) => {
      const { applicationId } = params as { applicationId: string }
      const response: OnboardingDocumentCreateModeWebPage = await getOnboardingDocumentCreateModeWebPage(
        Number(applicationId)
      )

      if (!response?.companies) {
        throw notFound()
      }

      return {
        webPageData: response
      }
    },
    component: () => {
      const { webPageData } = useLoaderData({ strict: false })

      if (!webPageData) throw notFound()

      return (
        <>
          <Sidebar companies={webPageData.companies} />
          <SetupDocumentsCreate />
        </>
      )
    },
    shouldReload: (p) => p.cause === 'enter'
  })
